import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import zoom from "./function_zoom";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    $(document).ready(function () {
        var selector = "[data-layout='panning-image']";

        if ($(selector).length) {
            if (log) console.log("%cfunction_panning-image.js initialized", "color: green;");
            gsap.registerPlugin(ScrollTrigger);

            var offset = getCssVarValue("--space-global") * 2;
            var initialScale = (window.innerWidth - offset) / window.innerWidth;

            $(selector).each(function () {
                var $instance = $(this);
                var $keyframes = $instance.find("[data-keyframe]");
                var $target = $instance.find("[data-target]");
                var $frame = $instance.find("figure");
                var $progress = $instance.find(".progress-bar");

                $frame.css("transform", `scale(${initialScale})`);

                $keyframes.each(function () {
                    ScrollTrigger.create({
                        scroller: window,
                        trigger: $(this)[0],
                        start: "top top",
                        end: "bottom top",
                        onEnterBack: enterHandler,
                        onEnter: enterHandler,
                        // onLeave: leaveHandler,
                        // onLeaveBack: leaveHandler,
                        // markers: true,
                    });
                });

                gsap.to($frame[0], {
                    alpha: 1,
                    scale: 1,
                    ease: "sine.inOut",
                    duration: getCssVarValue("--duration-md") / 1000,
                    scrollTrigger: {
                        scroller: window,
                        trigger: $instance.find(".pan-intro")[0],
                        start: "top top",
                        endTrigger: $instance.find(".pan-outro")[0],
                        end: "top top",
                        toggleActions: "play reverse play reverse",
                    },
                });

                gsap.to($progress[0], {
                    scaleX: 1,
                    ease: "none",
                    scrollTrigger: {
                        scroller: window,
                        trigger: $instance.find(".pan-core")[0],
                        start: "top top",
                        endTrigger: $instance.find(".pan-outro")[0],
                        end: "top top",
                        toggleActions: "play reverse play reverse",
                        scrub: 1,
                        onToggle: function (self) {
                            $progress.toggleClass("on");
                        },
                    },
                });

                /*
                ScrollTrigger.create({
                    trigger: $instance.find(".pan-intro")[0],
                    start: "top top",
                    endTrigger: $instance.find(".pan-outro")[0],
                    end: "bottom bottom",
                    onToggle: function () {
                        $frame.toggleClass("inset-global alpha-0.6");
                    },
                    // onLeave: leaveHandler,
                    // onLeaveBack: leaveHandler,
                    // markers: true,
                });
                */

                function enterHandler(_self) {
                    // if (!_self.isActive) return;

                    var $keyframe = $(_self.trigger);
                    var focus = $keyframe.data("focus");
                    var scale = $keyframe.data("scale");

                    zoom($target, focus, scale);
                }
            });
        }
    });
})();
